import React, {useState, useEffect, useContext, useMemo} from "react";
import Box from "@mui/material/Box";
import {get, uploadBarcodes, remove} from '@api/benefits';
import makeStyles from "@material-ui/core/styles/makeStyles";
import {DataGrid} from '@mui/x-data-grid';
import {Button, Switch, Typography, Stack, Pagination } from '@mui/material';
import {Modal} from "@modal";
import CSVReader from 'react-csv-reader'
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import { updateStatus } from "@api/benefits"
import { useConfirm } from 'material-ui-confirm';
import {useHistory} from "react-router";
import { renderCellExpand } from "@components/renderCellExpand";
import { updateHideColumnGridData, getState } from "@services/state";
import {isHideColumnGridData, removeState, updateState} from "../../services/state";
import Checkbox from '@mui/material/Checkbox';
import {SUPER_ADMIN} from "../../constants";
import {RoleContext} from "../../hoc/role";
import Link from '@mui/material/Link';
import {removeBarcodes} from "../../api/benefits";

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    button: {
        width: '100%',
        margin: '10px',
    }
});

const data = [
    {field: 'id', headerName: 'id', minWidth: 150, filterable: false, renderCell: renderCellExpand},
    {field: 'imageUrl', headerName: 'imageUrl', filterable: false, renderCell: renderCellExpand},
    {field: 'imageUrlSL', headerName: 'imageUrlSL', filterable: false, renderCell: renderCellExpand},
    {field: 'category', headerName: 'category', filterable: false, renderCell: renderCellExpand},
    {field: 'rules', headerName: 'rules', filterable: false, renderCell: renderCellExpand},
    {field: 'stores', headerName: 'stores', filterable: false, renderCell: renderCellExpand},
    {field: 'name', headerName: 'name', minWidth: 150, renderCell: renderCellExpand},
    {field: 'title', headerName: 'title', renderCell: renderCellExpand},
    {field: 'descriptions', headerName: 'descriptions', filterable: false, renderCell: renderCellExpand},
    {field: 'supplier', headerName: 'supplier', renderCell: renderCellExpand},
    {field: 'discount', headerName: 'discount', filterable: false, renderCell: renderCellExpand},
    {field: 'type', headerName: 'type', renderCell: renderCellExpand},
    {field: 'validity', headerName: 'validity', filterable: false, renderCell: renderCellExpand},
    {field: 'statusModifiedBy', headerName: 'Status modified by', renderCell: renderCellExpand},
    // {field: 'category', headerName: 'Category', renderCell: renderCellExpand},
    {field: 'segments', headerName: 'Segments', renderCell: renderCellExpand},
    {field: 'maxRewardsPerUser', headerName: 'maxRewardsPerUser', filterable: false, renderCell: renderCellExpand},
];

export const Benefits = () => {
        const stateName = 'stateDataGridBenefits';
        let history = useHistory();
        const classes = useStyles();
        const {role} = useContext(RoleContext);
        const {setLoading} = useContext(LoadingContext);
        const {setErrorMessage, setSuccessMessage} = useContext(MessageContext);
        const [rows, setRows] = useState([]);
        const [columns, setColumns] = useState(updateHideColumnGridData(data, stateName));
        const state = getState(stateName);
        const [sortModel, setSortModel] = useState(state && state.sort ? state.sort : []);
        const [filterModel, setFilterModel] = useState(state && state.filter ? state.filter : {items:[]});
        const [openImgAddModal, setOpenImgAddModal] = useState(false);
        const [openImgSLAddModal, setOpenImgSLAddModal] = useState(false);
        const [openAddBenafitModal, setOpenAddBenafitModal] = useState(false);
        const [openUpdateBenafitModal, setOpenUpdateBenafitModal] = useState(false);
        const [openBenefitStatisticsModal, setOpenBenefitStatisticsModal] =  useState(false)
        const [editBenefits, setEditBenefits] = useState({});
        const [headers, setHeaders] = useState();
        const confirm = useConfirm();

        const onStatusChange = async (val, data) => {
            try{
                await confirm({title: '', description: 'Attention! If you deactivate the last benefit  in the category, the category will be also deactivated!' })
                if (val) {
                    val = "ACTIVE"
                }
                else val = "INACTIVE"

                await updateStatus(val, data.row.id)

                await loadBenefits();
            }catch (e){
                setRows([]);
                await loadBenefits();
                if(typeof e === 'string') setErrorMessage(e);
            }

        }

        const onUploadBarcodes = async (id, data) => {
            try {
                setLoading(true);
                setErrorMessage(null);

                const input = new FormData();
                input.append('file', data);

                await uploadBarcodes(id, input).then(res => setSuccessMessage(res));
                await reloadBenefits();
            } catch (e) {
                setErrorMessage(e);
            }
            setLoading(false);
        }

        const resetLocalStorage = () => {
            removeState(stateName);
            window.location.reload();
        }

        const onChangePage = async (e, value) => {
            try {
                e.preventDefault();
                setLoading(true);
                setErrorMessage(null);
                const state = getState(stateName);
                const sort = state ? state.sort : {};
                const [body, headers] = await get({page: value - 1, sort});
                setRows([...body])
                headers.page *= 1;
                headers.pages *= 1;
                updateState({page: value}, stateName);

                setHeaders(headers);
                
            } catch (e) {
                setErrorMessage(e);
            }
            setLoading(false);
        }

        const onRemove = async (id) => {
            try {
                setLoading(true);
                setErrorMessage(null);

                await remove(id);
                await reloadBenefits();
                setLoading(false);
            } catch (e) {
                setErrorMessage(e);
            }
            setLoading(false);
        }

        const onRemoveBarcodes = async (id) => {
            try {
                setLoading(true);
                setErrorMessage(null);

                await removeBarcodes(id);
                loadBenefits();
            } catch (e) {
                setErrorMessage(e);
            }
            setLoading(false);
        }

       useMemo(() => {
           columns.push({
               field: 'category',
               headerName: 'Category',
               editable: true,
               renderCell: (data) => {
                   return (
                       <>
                           <div>{data?.value?.name}</div>
                       </>
                   )}
           })

           columns.push({
               field: 'isDefault',
               headerName: 'isDefault',
               editable: true,
               renderCell: (data) => {
                   return (
                       <>
                           <Checkbox defaultChecked={data.value} disabled />
                       </>
                   )}
           })
           columns.push({
               field: 'status',
               headerName: 'status',
               editable: true,
               hide: isHideColumnGridData('status', stateName),
               renderCell: (data) => {
                   return (
                       <>
                           <Switch defaultChecked={data.row.status === "ACTIVE" ? true : false}
                                   onChange={e => onStatusChange(e.target.checked, data)}
                                   name={data.row.id} />
                       </>
                   )}
           })

           columns.push({
               field: 'Add barcodes',
               headerName: 'Add barcodes',
               filterable: false,
               hide: isHideColumnGridData('Add barcodes', stateName),
               minWidth: 200,
               renderCell: (data) => {
                   return (
                       ["COUPON", "POINTS", "PRODUCT"].includes(data.row.type) ? <CSVReader onFileLoaded={(data1, fileInfo, originalFile) => onUploadBarcodes(data.row.id, originalFile)}/> : "")
               }
           })

           columns.push({
               field: 'Limits',
               headerName: 'Limits',
               filterable: false,
               hide: isHideColumnGridData('Limits', stateName),
               renderCell: (data) => {
                   return (["COUPON", "POINTS", "PRODUCT"].includes(data.row.type) ? <Button variant="outlined" onClick={() => {
                       removeState('stateBarcodesLimit');
                       history.push({
                           pathname: '/barcodes-limit',
                           search: `?benefitId=${data.id}`,
                       })
                   }}>Limits</Button> : '')
               }
           })

           columns.push({
               field: 'Edit',
               headerName: 'Edit',
               filterable: false,
               hide: isHideColumnGridData('Edit', stateName),
               renderCell: ({id}) => {
                   return <Button variant="outlined" onClick={() => {
                       setEditBenefits({id})
                       setOpenUpdateBenafitModal(!openUpdateBenafitModal)
                   }}>Edit</Button>;
               }
           })

           columns.push({
               field: 'Statistics',
               headerName: 'Statistics',
               filterable: false,
               hide: isHideColumnGridData('Statistics', stateName),
               renderCell: (data) => {
                   return <Button variant="outlined" onClick={() => {
                       setEditBenefits(data.id)
                       setOpenBenefitStatisticsModal(!openBenefitStatisticsModal)
                   }}>Statistics</Button>;
               }
           })

           // columns.push({
           //     field: 'Add description',
           //     headerName: 'Add description',
           //     width: 200,
           //     renderCell: ({id}) => {
           //         return <Button variant="outlined" onClick={() => {
           //             setEditBenefits({id})
           //             setOpenDescriptionAddModal(!openDescriptionAddModal)
           //         }}>Add descriptions</Button>;
           //     }
           // })

           columns.push({
               field: 'Add Image',
               headerName: 'Add Image',
               filterable: false,
               hide: isHideColumnGridData('Add Image', stateName),
               renderCell: (data) => {
                   return <Button variant="outlined" onClick={() => {
                       setEditBenefits(data.row)
                       setOpenImgAddModal(!openImgAddModal)
                   }}>Add Image</Button>;
               }
           })

           columns.push({
               field: 'Add Img SL',
               headerName: 'Add Img SL',
               filterable: false,
               hide: isHideColumnGridData('Add Img SL', stateName),
               renderCell: (data) => {
                   return <Button variant="outlined" onClick={() => {
                       setEditBenefits(data.row)
                       setOpenImgSLAddModal(!openImgSLAddModal)
                   }}>Add Img SL</Button>;
               }
           })

           if(role === SUPER_ADMIN){
               columns.push({
                   field: 'delete',
                   headerName: 'Delete Benefit',
                   filterable: false,
                   renderCell: (data) => {
                       return <Button color="error" variant="outlined" onClick={() => {
                           onRemove(data.id)
                       }}>Remove</Button>;
                   }
               })
               columns.push({
                   field: 'deleteBarcodes',
                   headerName: 'Delete Baracodes',
                   filterable: false,
                   renderCell: (data) => {
                       return <Button color="error" variant="outlined" onClick={() => {
                           onRemoveBarcodes(data.id)
                       }}>Remove</Button>;
                   }
               })
           }

           setColumns(columns);
       }, [])

        const loadBenefits = async (loading=true) => {
            try {
                if(loading) setLoading(true);
                setErrorMessage(null);
                const state = getState(stateName);
                const page = state && state.page ? state.page - 1 : 0;
                const sort = state ? state.sort : {};
                const filter = state ? state.filter : {};
                const [body, headers] = await get({page, sort, filter});

                setRows([...body])
                headers.page *= 1;
                headers.pages *= 1;
                setHeaders(headers);
            } catch (e) {
                setErrorMessage(e);
            }
            setLoading(false);
        }

        const reloadBenefits = async () => {

            // setOpenDescriptionAddModal(false);
            setOpenBenefitStatisticsModal(false)
            setOpenImgAddModal(false);
            setOpenImgSLAddModal(false);
            setOpenAddBenafitModal(false);
            setOpenUpdateBenafitModal(false);

            await loadBenefits(false);
        }

        const addBenefit = async () => {
            setOpenAddBenafitModal(!openAddBenafitModal);
        }

        const onStateChange = (e) => {
            updateState({columns: e.columns.lookup}, stateName);
        }

        const onSortModelChange = (e) => {
            setSortModel(e)
            updateState({sort: e}, stateName);
            loadBenefits();
        }

        const onFilterModelChange = (e) => {
            setFilterModel(e)
            updateState({filter: e}, stateName);
            loadBenefits();
        }

        useEffect(() => {
            loadBenefits();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [sortModel])

        return (
            <Box
                className={classes.root}
                display={"flex"}
                flexDirection={'column'}
                alignItems={"center"}
            >
                <Box display={"flex"}
                     justifyContent={"flex-end"}
                     justifyItems={"flex-end"} className={classes.button}>
                    <Button variant="contained" onClick={addBenefit}>Add Benefit</Button>
                </Box>
                <Box style={{minHeight: 400, width: '100%'}}>
                    <DataGrid
                        autoHeight={true}
                        rows={rows}
                        columns={columns}
                        checkboxSelection
                        sortModel={sortModel}
                        filterModel={filterModel}
                        onStateChange={(e) => onStateChange(e)}
                        onSortModelChange={(e) => onSortModelChange(e)}
                        onFilterModelChange={(e) => onFilterModelChange(e)}
                    />
                    <Stack spacing={2}>
                        {
                            headers?.pages && headers?.page ? (<><Typography>Page: {headers?.page}</Typography>
                                <Pagination count={headers?.pages} page={headers?.page} onChange={onChangePage}/>
                            </>) : ''
                        }
                    </Stack>

                    <Box display={"flex"}
                         justifyContent={"flex-end"}
                         justifyItems={"flex-end"}>
                        <Button variant="outlined" sx={{marginRight: 2, marginBottom: 2}} onClick={() => resetLocalStorage()}>Reset</Button>
                    </Box>
                </Box>
                <Box
                     style={{width: '100%'}}
                     display={"flex"}
                     justifyContent={"flex-start"}
                     flexDirection={'column'}>
                    <Typography>Notes:</Typography>
                    <Typography>Barcode Min length – 8 symbols</Typography>
                    <Typography>Use <Link href="/assets/csv/barcodeExample.csv">CSV Example file</Link> to upload barcodes for Coupons.</Typography>
                </Box>
                {openBenefitStatisticsModal && <Modal
                    isOpen={openBenefitStatisticsModal}
                    data={editBenefits}
                    onClose={(data) => reloadBenefits(data)}
                    name='BenefitStatistics'/>}
                {/*{openDescriptionAddModal && <Modal*/}
                {/*    isOpen={openDescriptionAddModal}*/}
                {/*    data={editBenefits}*/}
                {/*    onClose={(data) => reloadBenefits(data)}*/}
                {/*    name='AddDescription'/>}*/}
                {openImgAddModal && <Modal
                    isOpen={openImgAddModal}
                    data={editBenefits}
                    size={'fullscreen'}
                    title={editBenefits.type.toLowerCase() === 'postcard' ? 'Add postcard' : 'Add Coupon Image'}
                    onClose={(data) => reloadBenefits(data)}
                    name='AddImage'
                    languageIndex={1}
                />}
                {openImgSLAddModal && <Modal
                    isOpen={openImgSLAddModal}
                    data={editBenefits}
                    size={'fullscreen'}
                    title={editBenefits.type.toLowerCase() === 'postcard' ? 'Add postcard' : 'Add Coupon Image'}
                    onClose={(data) => reloadBenefits(data)}
                    name='AddImage'
                    languageIndex={2}
                />}
                {openAddBenafitModal && <Modal
                    isOpen={openAddBenafitModal}
                    onClose={(data) => reloadBenefits(data)}
                    name='CreateBenefit'/>}
                {openUpdateBenafitModal && <Modal
                    isOpen={openUpdateBenafitModal}
                    data={editBenefits}
                    onClose={(data) => reloadBenefits(data)}
                    name='UpdateBenefit'/>}
            </Box>
        );
    }
;